import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksByPlaybookIdDeploymentsOptions } from '@onefootprint/fetch-dashboard';
import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Button, LoadingSpinner } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeploymentEntry from './deployment-entry';
type PastDeploymentsListProps = {
  playbookId: string;
  playbookVersions: PlaybookVersionNoGraph[];
  activeDeploymentId?: string;
};
const PAGE_SIZE = 5;
const PastDeploymentsList = t0 => {
  const $ = _c(21);
  const {
    playbookId,
    playbookVersions,
    activeDeploymentId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deployment.past"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const [page, setPage] = useState(0);
  let t2;
  if ($[1] !== page || $[2] !== playbookId) {
    t2 = getOrgPlaybooksByPlaybookIdDeploymentsOptions({
      path: {
        playbookId
      },
      query: {
        page,
        pageSize: PAGE_SIZE
      }
    });
    $[1] = page;
    $[2] = playbookId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    isPending
  } = useQuery(t2);
  let t3;
  if ($[4] !== activeDeploymentId || $[5] !== data?.data || $[6] !== data?.meta || $[7] !== isPending || $[8] !== page || $[9] !== playbookVersions || $[10] !== t) {
    let t4;
    if ($[12] !== activeDeploymentId) {
      t4 = d => d.id !== activeDeploymentId;
      $[12] = activeDeploymentId;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    const deployments = (data?.data ?? []).filter(t4);
    const hasNextPage = !!data?.meta.nextPage;
    let t5;
    if ($[14] !== t) {
      t5 = t(_temp);
      $[14] = t;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== t5) {
      t6 = <h3 className="text-label-2 text-primary">{t5}</h3>;
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    const t7 = !isPending && deployments.length > 0 && (page > 0 || hasNextPage) && <div className="flex gap-2">{page > 0 && <Button size="compact" variant="secondary" onClick={() => setPage(_temp2)}>{t(_temp3)}</Button>}{hasNextPage && <Button size="compact" variant="secondary" onClick={() => setPage(_temp4)}>{t(_temp5)}</Button>}</div>;
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
      t8 = <div className="flex items-center justify-between gap-2">{t6}{t7}</div>;
      $[18] = t6;
      $[19] = t7;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t3 = <div className="flex flex-col gap-3">{t8}{isPending ? <div className="flex justify-center p-4"><LoadingSpinner /></div> : deployments.length === 0 ? <div className="p-4 rounded border border-tertiary text-body-2 text-tertiary">{t(_temp6)}</div> : <div className="flex flex-col gap-2">{deployments.map(deployment => <DeploymentEntry key={deployment.id} deployment={deployment} playbookVersions={playbookVersions} activeDeploymentId={activeDeploymentId} />)}</div>}</div>;
    $[4] = activeDeploymentId;
    $[5] = data?.data;
    $[6] = data?.meta;
    $[7] = isPending;
    $[8] = page;
    $[9] = playbookVersions;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default PastDeploymentsList;
function _temp($) {
  return $.title;
}
function _temp2(p) {
  return p - 1;
}
function _temp3($_0) {
  return $_0.previousPage;
}
function _temp4(p_0) {
  return p_0 + 1;
}
function _temp5($_1) {
  return $_1.nextPage;
}
function _temp6($_2) {
  return $_2.empty;
}